export enum CabinetConfigurationValueType {
  Boolean,
  Value,
  Option
}
